module.exports = __webpack_public_path__ + "img/3.119d824a.jpeg";